import React from "react";
import Fonts from "../../../../Config/Fonts";
import Colors from "../../../../theme/Colors";
import { ManufacturesTableCellHeader } from "../../../../Constants/MockData";

const ManufacturesTableHeader = () => {
  return (
    <thead>
        {ManufacturesTableCellHeader.map((tCell, index) => (
          <th key={index} style={{
        fontSize: 12,
            fontWeight: "500",
            fontFamily: Fonts.Poppins,
            color: Colors.breadCrumbsColor,
            position: "sticky",
            top: 0,
            textAlign: "center",
            padding: "8px 5px",
            border: "1px solid #E6E6E6",
          }}>
            {tCell?.header}
          </th>
        ))}
    </thead>
  );
};

export default ManufacturesTableHeader;
